import comp from "./OrganizationSelector";
export default comp;
